import { InventorySwagpack } from "../../../models/inventory/InventorySwagpack";
import { SwagpackFilters } from "../../../models/inventory/InventorySwagpackFilter";
import {
  APIBlobResponse,
  PaginatedAPIResponse,
} from "../../../models/NetworkResponse";
import { getAPI } from "../../../api/Networking";

export default class SwagpacksAPI {
  getSwagpacks = async (
    filters: SwagpackFilters,
  ): Promise<PaginatedAPIResponse<InventorySwagpack> | APIBlobResponse> => {
    try {
      const queryParams = new URLSearchParams();

      if (filters.page_no)
        queryParams.append("page_no", filters.page_no.toString());

      if (filters.limit) queryParams.append("limit", filters.limit.toString());

      if (filters.search_text)
        queryParams.append("search_text", filters.search_text.toString());

      if (
        filters &&
        filters.out_of_stock !== null &&
        filters.out_of_stock !== undefined
      ) {
        queryParams.append("out_of_stock", filters.out_of_stock.toString());
      }

      if (filters.inventory_id)
        queryParams.append("inventory_id", filters.inventory_id.toString());

      if (filters.sort_by)
        queryParams.append("sort_by", filters.sort_by.toString());

      if (filters.sort_type)
        queryParams.append("sort_type", filters.sort_type.toString());

      const response = await getAPI(
        `/v5/swagpacks/list?${queryParams.toString()}`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };
}
